import React, { useState, useEffect } from 'react';

import Panel from '../components/Panel';

import classes from './MainPage.module.css';
import textClasses from '../Text.module.css';

function MainPage() {
    const [fps, setFps] = useState(0);

    useEffect(() => {
        let lastFrameTime = performance.now();
        let frameCount = 0;

        const updateFps = (currentTime) => {
            frameCount++;
            const delta = currentTime - lastFrameTime;
            if (delta >= 100) {
                setFps(Math.round((frameCount * 1000) / delta));
                frameCount = 0;
                lastFrameTime = currentTime;
            }
            requestAnimationFrame(updateFps);
        };

        requestAnimationFrame(updateFps);
    }, []);

    const date = new Date();
    const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const dayName = dayNames[date.getDay()];
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    const formattedDate = `${dayName} ${day}/${month}`;
    const formattedTime = `${hours}:${minutes}:${seconds}`;

    return (
        <div className={classes.mainPage}>
            <div className={classes.header}>
                <div className={`${textClasses.text} ${textClasses.blue} ${textClasses.blink}`} style={{ margin: "1px 10px 1px 10px" }}>
                    LOAD
                </div>
                <div className={`${textClasses.text} ${textClasses.white}`} style={{ margin: "1px 10px 1px 10px" }}>
                    {formattedDate}
                </div>
                <div className={`${textClasses.text} ${textClasses.white}`} style={{ margin: "1px 10px 1px 10px" }}>
                    {formattedTime}
                </div>
                <div className={`${textClasses.text} ${textClasses.white}`} style={{ margin: "1px 10px 1px 10px" }}>
                    FPS:{fps}
                </div>
            </div>
            <div className={classes.content}>
                <Panel style={{ gridArea: "a" }} title="ANNOUNCEMENTS" content={
                    <div>
                        <div className={`${textClasses.text} ${textClasses.black}`}>
                            ----WEBSITE STARTED BEING BUILT!----
                        </div>
                        <br />
                        <div className={`${textClasses.text} ${textClasses.blue}`}>
                            The entire theme will be inspired by TempleOS just because I love how unique it is.
                        </div>
                        <br />
                        <div className={`${textClasses.text} ${textClasses.orange} ${textClasses.blink}`}>
                            Coming soon
                        </div>
                    </div>
                } />
                <Panel style={{ gridArea: "b" }} title="GAMES & APPS" content={
                    <div>
                        <div className={`${textClasses.text} ${textClasses.green}`}>
                        // TODO for now
                        </div>
                        <br />
                        <div className={`${textClasses.text} ${textClasses.blue}`}>
                            Current ideas: planet terraformer simulator
                        </div>
                    </div>
                } />
            </div>
        </div>
    );
}

export default MainPage;